export default __webpack_public_path__ + "static/media/empty-task-bundles-tasks.77fa474b.svg";